export const colors = {
    BLUE: '#0085FF',
    GREY: '#D9D9D9',
    RED: '#FF4D4D'
}